export default __webpack_public_path__ + "static/media/imageDemonstration.17246351.png";